import { Injectable } from '@angular/core';
import { EntityService } from '../../../../rest/entity.service';
import { JQueryHTTPClient } from '../../../../rest/JQueryHTTPClient';
import { Rest_task } from './rest_client_task';
import { Rest } from '../../../../rest/rest_client';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';
import { AuthenticationService } from '../../../../core/services/authentication/authentication.service';
import { NotificationsService, Severity } from '../../../../services/notifications-service/notifications.service';
import { TranslateService } from '@ngx-translate/core';
import { I18nService } from 'app/services/i18n/i18n.service';

@Injectable()
export class UserTaskService extends EntityService<Rest.User> {
	client: Rest.RestApplicationClient;
	public userType: number = 0;

	constructor(
		private jquery: JQueryHTTPClient,
		private http: HttpClient,
		private auth: AuthenticationService,
		private notificationsService: NotificationsService,
		private translate: TranslateService,
		protected i18n: I18nService
	) {
		super();
		this.client_task = new Rest_task.RestApplicationClient(jquery);
		this.client = new Rest.RestApplicationClient(jquery);
	}

	getPage(arg0: Rest.ListPaginationRequest): Rest.RestResponse<Rest.Page<Rest.User>> {
		return this.client_task.User_getPage(arg0, this.userType);
	}

	user_getPage(arg0: Rest.ListPaginationRequest, userType: number): Rest.RestResponse<Rest.Page<Rest.User>> {
		return this.client_task.User_getPage(arg0, userType);
	}

	create(arg0: Rest.User): Rest.RestResponse<Rest.User> {
		return this.client_task.User_create(arg0, this.userType);
	}

	createUser(arg0: Rest.User, userType: number): Rest.RestResponse<Rest.User> {
		return this.client_task.User_create(arg0, userType);
	}

	// delete(arg0: Rest.User[]): Rest.RestResponse<void> {
	//     return this.client_task.Userboapp_delete(arg0[0],1);
	// }

	update(arg0: Rest.User): Rest.RestResponse<Rest.User> {
		return this.client_task.User_update(arg0, this.userType);
	}

	updateUser(arg0: Rest.User, userType: number): Rest.RestResponse<Rest.User> {
		return this.client_task.User_update(arg0, userType);
	}

	deleteUser(arg0: Rest.User, projectTypeId: number): Rest.RestResponse<any> {
		return this.client_task.User_delete({ userId: arg0.id, projectTypeId: projectTypeId });
	}

	changeStatus(arg0: number[], queryParams?: { status?: boolean }): Rest.RestResponse<void> {
		return this.client.User_changeStatus(arg0, queryParams);
	}

	find(arg0: string, queryParams?: { id?: number }): Rest.RestResponse<Rest.User> {
		return this.client_task.User_find(arg0, queryParams);
	}

	getPageAndFilters(arg0: Rest.ListPaginationRequest): Rest.RestResponse<Rest.ListPageAndFilters<Rest.User>> {
		return this.client_task.User_getPageAndFilters(arg0);
	}

	getPermissions(): Rest.RestResponse<Rest.Roleprofilehierarchy> {
		return this.client_task.Userbo_getPermissions();
	}

	setUserPlannerFeatures(userPlanner: Rest_task.UserPlanner, userId: number): Rest.RestResponse<Rest.GenericResp> {
		return this.client_task.User_setPlannerFeatures(userPlanner, userId);
	}

	setUserPlannerCosts(userPlanner: Rest_task.UserPlanner, userId: number): Rest.RestResponse<Rest.GenericResp> {
		return this.client_task.User_setPlannerCosts(userPlanner, userId);
	}
	setUserPlannerLocalizations(
		userPlanner: Rest_task.UserPlanner,
		userId: number
	): Rest.RestResponse<Rest.GenericResp> {
		return this.client_task.User_setPlannerLocalizations(userPlanner, userId);
	}

	public convertDelegations_To_DelegationUsers(delegations: Rest_task.Delegation[]): Rest_task.DelegationUser[] {
		return delegations?.map((delegation) => {
			return {
				id: 0,
				client: null,
				user: null,
				delegation: delegation,
			};
		});
	}

	public convertUsers_To_DelegationUsers(users: Rest.User[]): Rest_task.DelegationUser[] {
		return users?.map((user) => {
			return {
				id: 0,
				client: null,
				user: user,
				delegation: null,
			};
		});
	}

	public convertDelegationUsers_To_Users(delegationUsers: Rest_task.DelegationUser[]): Rest.User[] {
		return delegationUsers?.map((delegationUser) => {
			return JSON.parse(JSON.stringify(delegationUser?.user));
		});
	}

	handleDeleteError(error: any) {
		let message = this.translate.instant('administration.usersbo.deleteError'); // Default error message

		if (error && error.error_code) {
			switch (error.error_code) {
				case 622:
					message = this.translate.instant('administration.deleteErrors.errorActiveRoutes');
					break;
				case 623:
					message = this.translate.instant('administration.deleteErrors.errorSpecificPermissions');
					break;
				default:
					message = this.translate.instant('administration.deleteErrors.unknownError');
					break;
			}
		}
		this.notificationsService.add(Severity.error, this.translate.instant('i18nMigrated.x2'), message);
	}

	/* //De moment no s'utlitza
       public convertDelegationUsers_To_Delegation(delegationUsers: Rest_task.DelegationUser[],): Rest_task.Delegation[] {
           return delegationUsers.map(delegationUser => {
               // return {...delegationUser.delegation};
               return JSON.parse(JSON.stringify(delegationUser.delegation))
           });
       }
       //Busca en el array de delegaciones del usuario (userDelegations) si coincide aluna delegación de las disponibles(availableDelegationUser) y la mapea en availableDelegationUser
       public mapDelegationUserAssignations(availableDelegationUser: Rest_task.DelegationUser[], userDelegations: Rest_task.DelegationUser[]): Rest_task.DelegationUser[] {
           if (userDelegations) {
               userDelegations.forEach(userDelegation => {
                   const index = availableDelegationUser.findIndex(delegationUser => delegationUser.delegation.id === userDelegation.delegation.id);
                   if (index !== -1) {
                       availableDelegationUser[index] = userDelegation;
                   }
               });
           }
           return availableDelegationUser;
       } */
}
